/**
 * Leaf module used to break the axios ↔ store import cycle.
 * App/store registers a logout handler; axios triggers it on refresh failure.
 * Listing/form modules register cache invalidators cleared on logout.
 */
type LogoutHandler = () => void | Promise<void>;

let logoutHandler: LogoutHandler | null = null;
const sessionCacheInvalidators: Array<() => void> = [];

export const registerLogoutHandler = (handler: LogoutHandler): void => {
    logoutHandler = handler;
};

export const triggerLogout = async (): Promise<void> => {
    if (logoutHandler) {
        await logoutHandler();
    }
};

export const registerSessionCacheInvalidator = (invalidate: () => void): void => {
    sessionCacheInvalidators.push(invalidate);
};

/** Clears listing reuse keys and any registered in-memory session caches. */
export const invalidateSessionCaches = (): void => {
    sessionCacheInvalidators.forEach((invalidate) => invalidate());
};
